module.exports = __webpack_public_path__ + "img/nh3.0f2746ce.svg";